import React from "react";
import { cx } from "class-variance-authority";

export const ScrollView: React.FC<{
  className?: string;
  children?: React.ReactNode;
}> = ({ children, className }) => {
  return (
    <div className="flex-1 h-full w-full relative overflow-y-hidden flex flex-col items-start">
      <div
        className={cx(
          "overscroll-y-auto absolute inset-0 overflow-y-auto flex-1 styled-scroll",
          className
        )}
      >
        {children}
      </div>
    </div>
  );
};

interface StackProps extends React.HTMLProps<HTMLDivElement> {}

export const HStack = React.forwardRef<HTMLDivElement, StackProps>(
  ({ children, className, ...props }: StackProps, ref) => {
    return (
      <div className={cx("flex", className)} {...props} ref={ref}>
        {children}
      </div>
    );
  }
);

export const VStack = React.forwardRef<HTMLDivElement, StackProps>(
  ({ children, className, ...props }: StackProps, ref) => {
    return (
      <div className={cx("flex flex-col", className)} {...props} ref={ref}>
        {children}
      </div>
    );
  }
);
